import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useTheme,
  Box,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import "moment/locale/id";

const UbahTanggalModal = ({
  open,
  onClose,
  onSubmit,
  selectedTransaksi,
  tanggalPengganti,
  setTanggalPengganti,
}) => {
  const theme = useTheme();

  const handleSubmit = () => {
    if (tanggalPengganti) {
      onSubmit(tanggalPengganti.format("YYYY-MM-DD"));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ubah Tanggal Transaksi</DialogTitle>
      <DialogContent>
        <Typography variant="body1" mb={2}>
          Mengubah tanggal untuk transaksi: <strong>{selectedTransaksi?.nama}</strong>
        </Typography>
        
        {selectedTransaksi?.tanggal && (
          <Typography variant="body2" color="text.secondary" mb={1}>
            Tanggal sebelumnya: <strong>{moment(selectedTransaksi.tanggal).format("DD MMMM YYYY")}</strong>
          </Typography>
        )}

        <Box mt={2}>
          <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="id">
            <DatePicker
              label="Tanggal Pengganti"
              value={tanggalPengganti}
              onChange={(newValue) => {
                setTanggalPengganti(newValue);
              }}
              minDate={moment()}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "medium",
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="contained"
          color="inherit"
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            padding: "10px 20px",
          }}
          onClick={onClose}
        >
          Batal
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.background.alt,
            fontSize: "14px",
            fontWeight: "bold",
            padding: "10px 20px",
            "&:hover": {
              backgroundColor: theme.palette.secondary[500],
            },
          }}
          onClick={handleSubmit}
          disabled={!tanggalPengganti}
        >
          Simpan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UbahTanggalModal;
